import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../../utils/cx';
/** Internal core renderer. Do not export from the barrel. */
export function TypographyText({ as: As, roleClassName, color, extraStyle, style, children, className, id, role, ...rest }) {
    const hasInlineStyle = color !== undefined || extraStyle !== undefined || style !== undefined;
    const mergedStyle = hasInlineStyle
        ? {
            ...(color !== undefined ? { color } : undefined),
            ...extraStyle,
            ...style,
        }
        : undefined;
    return (_jsx(As, { className: cx(roleClassName, className), id: id, role: role, style: mergedStyle, ...rest, children: children }));
}
//# sourceMappingURL=_core.js.map